// extracted by mini-css-extract-plugin
export default {"parText":"CenteredPar_parText__g-R-J"};